/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import Vue from 'vue';
import {eventBus} from '@/services/eventbus';
import App from './App/index.vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import '@/validators';
import '@/plugins';
import '@/filters';
import '@/directives';
// import './registerServiceWorker';
import {Location, Route} from 'vue-router';
import Utils from '@/services/utils';

/**
 * Main entry point for vue application.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

Vue.config.productionTip = false;

// configure translations
i18n(store);

// (window as (Window & {App: Vue})).App = new Vue({
(window as any).App = new Vue({
    router,
    store,
    // tslint:disable-next-line
    render: (h) => h(App),
    methods: {
        navigate: (name: string): boolean => {
            try {
                // same route - trigger refresh
                if (name === router.currentRoute.name) {
                    return true;
                }

                const link:
                    { location: Location; route: Route; href: string; normalizedTo: Location; resolved: Route; } =
                    router.resolve({name});

                // invalid route
                if (!link || link.href === '/') {
                    return false;
                }

                router.push({name});

                return true;
            } catch (e) {
                return false;
            }
        },
        run: (name: string, ...params: (string|number|boolean)[]): boolean => {
            // use the event bus to refresh data
            eventBus.$emit(`cmd-${name}`, ...params);
            return true;
        },
        version: (): string => {
            return Utils.getVersion();
        },
    },
}).$mount('#app');
